import { defineComponent as _defineComponent } from 'vue'
import type { Snackbar } from '~/composables/useSnackbar'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSnackbar',
  props: {
    snackbar: null
  },
  emits: ['hideSnackbar'],
  setup(__props: any, { emit: emits }) {





return { __sfc: true,emits }
}

})